export const ProductProviders = [
  { id: 1, text: "Suregifts" },
  { id: 2, text: "Etap" },
];
